import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const ControlledDialog = ({
  open,
  onClose,
  title,
  onConfirm,
  content,
  actions,
  dialogProps = {}
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="controlled-dialog-title"
      aria-describedby="controlled-dialog-description"
      {...dialogProps}
    >
      {title && <DialogTitle id="controlled-dialog-title" style={{color: '#000', fontFamily: 'Inter, sans-serif', fontSize: '1.25rem', fontStyle: 'normal', fontWeight: 500, lineHeight: '1.5rem', marginTop: '2.5rem'}}>{title}</DialogTitle>}

      <DialogContent>
        <DialogContentText id="controlled-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>

      <DialogActions style={{marginBottom: '1.37rem', paddingRight: '1.37rem'}}>
        {actions ? (
          actions({ close: onClose, handleAgree: onConfirm })
        ) : (
<></>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ControlledDialog;
